import Share from './components/share';
import ContentShare from './components/contentShare';

export { Share, ContentShare };
